import { OverriddenBehaviors } from '@behavior-management/core/internal/override/OverrideEvaluation';
import { ExternalProvider } from '@behavior-management/core/internal/providers/types';

export class ActivitiesBMProvider implements ExternalProvider {
    private readonly overrideValues: OverriddenBehaviors = {} as OverriddenBehaviors;
    private readonly behaviorToFeatureMapping: Map<string, string> = new Map<string, string>();
    getOverrideValues = (): OverriddenBehaviors => this.overrideValues;

    getBehaviorToFeatureMapping = (whiteLabelId: number) => this.behaviorToFeatureMapping;
}
